import { Button, TextBlock, YearMonthRangePopover } from 'bench-internal-theme';
import { getISODateString, getLastDateOfMonth, toDate } from 'date-functions';
import React from 'react';
import styled from 'styled-components';

import { DateRange } from './types';

const SelectDateRangeNullStateWrapper = styled.div`
  align-items: center;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
`;

const SelectDateRangeNullStateLayout = styled.div`
  display: grid;
  grid-row-gap: 8px;
  grid-template-columns: 252px;
  grid-template-rows: min-content;
  text-align: center;
`;

type SelectDateRangeNullStateProps = {
  updateDateRange: (dateRange: DateRange) => any;
};

const SelectDateRangeNullState = ({ updateDateRange }: SelectDateRangeNullStateProps) => (
  <SelectDateRangeNullStateWrapper>
    <SelectDateRangeNullStateLayout>
      <TextBlock aria-label="General Ledger Page" styleType="title">
        General Ledger
      </TextBlock>
      <TextBlock>In order to view the General Ledger select a date range below.</TextBlock>
      <YearMonthRangePopover
        defaultDisplayedYear={new Date().getFullYear()}
        onRangeSelect={(startYearMonth: string | null, endYearMonth: string | null) => {
          if (!startYearMonth || !endYearMonth) return;
          updateDateRange({
            endDate: getISODateString(getLastDateOfMonth(endYearMonth)),
            startDate: getISODateString(toDate(startYearMonth)),
          });
        }}
      >
        {showPopover => (
          <Button
            aria-label="Select Date Range"
            onFocus={() => showPopover(true)}
            styleType="primary"
          >
            Select Date Range
          </Button>
        )}
      </YearMonthRangePopover>
    </SelectDateRangeNullStateLayout>
  </SelectDateRangeNullStateWrapper>
);

export default SelectDateRangeNullState;
